import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-court-emergency-call',
  templateUrl: './court-emergency-call.component.html',
  styleUrls: ['./court-emergency-call.component.scss']
})
export class CourtEmergencyCallComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
